import { GetterTree }   from 'vuex';
import { RootState }    from '@/store/store.types';
import { State }        from '@/views/settings/store/settings.state.store';
import { SettingsItem } from '@/views/settings/types/types';

const getters: GetterTree<State, RootState> = {
  getSettingsList(state): SettingsItem[] {
    return state.settingsList;
  },
};

export default getters;
